import React from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../data";
import { Creator } from "../../domain";
import "./AccountSettingsPage.css";

export const AccountSettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const [creator, setCreator] = React.useState<Creator | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [saving, setSaving] = React.useState(false);
  const [saved, setSaved] = React.useState(false);
  const [message, setMessage] = React.useState("");

  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) { navigate("/"); return; }
    (async () => {
      try {
        const c = await apiClient.getCreator();
        setCreator(c);
        setMessage(c.catalog_message || "");
      } catch {
        navigate("/");
      } finally {
        setLoading(false);
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleToggle = async () => {
    if (!creator) return;
    const next = !creator.show_in_catalog;
    setCreator({ ...creator, show_in_catalog: next });
    try {
      const updated = await apiClient.updateCreatorSettings({ show_in_catalog: next });
      setCreator(updated);
    } catch {
      setCreator({ ...creator, show_in_catalog: creator.show_in_catalog });
    }
  };

  const handleSaveMessage = async () => {
    if (!creator) return;
    setSaving(true);
    setSaved(false);
    try {
      const updated = await apiClient.updateCreatorSettings({ catalog_message: message });
      setCreator(updated);
      setMessage(updated.catalog_message || "");
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch {
      // ignore
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="account-settings-loading">Загрузка…</div>;
  }

  if (!creator) return null;

  return (
    <div className="account-settings">
      <div className="account-settings__section">
        <h1 className="account-settings__title">@{creator.instagram_username}</h1>
      </div>

      <div className="account-settings__card">

        <div className="account-settings__section-inner">
          <p className="account-settings__heading">Каталог</p>
          <div className="account-settings__row">
            <div>
              <span className="account-settings__label">Показывать в каталоге</span>
              <div className="account-settings__hint">
                Рекламодатели смогут найти тебя и просмотреть твой отчёт
              </div>
            </div>
            <button
              className={`toggle${creator.show_in_catalog ? " toggle--on" : ""}`}
              onClick={handleToggle}
              aria-pressed={creator.show_in_catalog}
            >
              <span className="toggle__thumb" />
            </button>
          </div>
        </div>

        <div className="account-settings__section-inner">
          <p className="account-settings__heading">Сообщение для рекламодателей</p>
          <div className="account-settings__hint">
            Расскажи о своей аудитории и форматах сотрудничества — увидят в каталоге
          </div>
          <div className="account-settings__field">
            <textarea
              id="catalog-message"
              className="account-settings__textarea"
              value={message}
              onChange={e => setMessage(e.target.value.slice(0, 300))}
              rows={4}
              placeholder="Пишу про путешествия и лайфстайл. Аудитория 25–35, Москва. Открыта к нативным интеграциям."
            />
            <div className="account-settings__footer">
              <span className="account-settings__char-count">{message.length} / 300</span>
              <button
                className="btn-primary"
                onClick={handleSaveMessage}
                disabled={saving}
              >
                {saving ? "Сохраняем…" : saved ? "✓ Сохранено" : "Сохранить"}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
